export default __webpack_public_path__ + "static/media/birthday.efe1a572.jpg";